var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkforce(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.591,
    height: 25.094,
    viewBox: "0 0 29.591 25.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1062",
    "data-name": "Groupe 1062",
    transform: "translate(-733.403 -545.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10408",
    "data-name": "Trac\\xE9 10408",
    d: "M762.994,573.23v9.846a1,1,0,0,1-1,1H734.4a1,1,0,0,1-1-1V573.23a.663.663,0,0,0,.139.015l12.006,4.355,2.484.906,2.484-.881,12.339-4.38A.63.63,0,0,0,762.994,573.23Z",
    transform: "translate(0 -13.159)",
    fill: "#ffc43e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10409",
    "data-name": "Trac\\xE9 10409",
    d: "M762.238,561.835l-14.2,5.039-13.878-5.039a.757.757,0,0,1-.757-.758V553.4a.757.757,0,0,1,.757-.758h28.076a.757.757,0,0,1,.758.758v7.68A.758.758,0,0,1,762.238,561.835Z",
    transform: "translate(-0.001 -3.426)",
    fill: "#ffc43e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10410",
    "data-name": "Trac\\xE9 10410",
    d: "M762.994,553.25v6.169a.662.662,0,0,1-.623.6,1,1,0,0,1-.135.01l-14.2,4.049-13.878-4.049a1.011,1.011,0,0,1-.135-.01.662.662,0,0,1-.622-.6V553.25a.694.694,0,0,1,.757-.609h28.076A.7.7,0,0,1,762.994,553.25Z",
    transform: "translate(0 -3.426)",
    fill: "#ffc43e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10411",
    "data-name": "Trac\\xE9 10411",
    d: "M763.091,549.214h-1.06v-1.048a1.289,1.289,0,0,0-1.288-1.288H757.3a1.289,1.289,0,0,0-1.288,1.288v1.048h-1.06v-1.048a2.351,2.351,0,0,1,2.348-2.348h3.446a2.351,2.351,0,0,1,2.348,2.348Z",
    transform: "translate(-10.821)",
    fill: "#ffc43e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkforce);
export default __webpack_public_path__ + "static/media/workforce.f988693ab1f29883a76291c8cd1bf25e.svg";
export { ForwardRef as ReactComponent };